import LeaderProfile from './Leader_Profile/LeaderProfile.jsx';
import { secretary } from './Leader_Profile/LeaderProfile.js'

const Secretary = () => {
    return (
        <LeaderProfile
            name={secretary.name}
            education={secretary.education}
            majorActivities={secretary.majorActivities}
            collegeIntro={secretary.collegeIntro}
            image={secretary.image}
            designation={secretary.designation}
        />
    )
}

export default Secretary
